import { render, staticRenderFns } from "./Pic.vue?vue&type=template&id=45f062f0"
import script from "./Pic.vue?vue&type=script&lang=js"
export * from "./Pic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports